// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Switch from "@material-ui/core/Switch";
import Assignment from "@material-ui/icons/Assignment";
import Create from "@material-ui/icons/Create";
import Edit from "@material-ui/icons/Edit";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import commonStyle from "assets/jss/common/common";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import axios from "axios";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect";
import ImageUpload from "components/CustomUpload/ImageUpload.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { t } from "i18next";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import "react-table/react-table.css";
import { api_url } from "redux/config.js";
import { getAllLanguages } from "utils/Languages";
import InputModal from "views/Shared/InputModal";
import TitleBox from "views/Shared/TitleBox";
import Toast from "views/Toast/Toast";
import RenderQuestion from "../RenderQuestions/RenderQuestion";
import EndMessageSection from "./components/EndMessageSection";




const SortableItem = sortableElement(({ value }) => <div>{value}</div>);

const SortableContainer = sortableContainer(({ children }) => {
  return <div>{children}</div>;
});


// survey part end
const styles = {
  ...regularFormsStyle,
  descriptionTextArea: {
    width: "100%",
    height: 150,
    borderColor: `#D2D2D2 !important`,
    borderWidth: `1px !important`,
    borderRadius: 4,
    fontSize: 14,
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontWeight: 400,
    color: `#495057`
  },
  overflowAuto: {
    overflow: "auto"
  }
};

class SurveyEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.survey_id,
      image_file: null,
      image_url: '',
      endmessages: [],
      mainData: [],
      languages: getAllLanguages(),
      surveyQuestions: [],

      selectedLanguage: 'en',
      available_languages: [],
      alert: null,
      sectionMoveTo: {},   // per-section target-position input (move section N to position X)
      listVersion: 0       // bumped on every reorder to force the sortable list to re-render
    };
  }
  componentDidMount() {

    this.onLoad()
  }


  verifyMainData = () => {
    const { mainData, selectedLanguage } = this.state
    let mainDataOfCurrentLanguage = mainData.filter((item) => item.language === selectedLanguage)[0]
    const { title } = mainDataOfCurrentLanguage;
    if (title.length === 0) {
      Toast(400, t('Please set title'));
      return false;
    }
    return true;
  };
  saveSurvey = async () => {
    if (this.verifyMainData()) {
      this.props.dispatch({ type: "LOAD_START" });

      if (this.state.image_file) {
        const fileData = new FormData();
        fileData.append("file", this.state.image_file);
        const result = await axios({
          url: api_url + "utils/file_upload",
          method: "post",
          data: fileData
        });
        if (result.data.success) {
          this.setState({
            image_url: result.data.file_url
          })
          this.updateSurvey({ image_url: result.data.file_url, main: this.state.mainData })
        } else {
          Toast(400, result.data.error);
        }
      } else {
        this.updateSurvey({ main: this.state.mainData })

      }

      this.props.dispatch({ type: "LOAD_END" });
    }
  };
  updateSurvey = async (updateData) => {
    this.props.dispatch({ type: "LOAD_START" });

    const result = await axios({
      url: api_url + "survey/update",
      method: "post",
      headers: {
        authorization: "Bearer ".concat(this.props.user.token)
      },
      data: {
        id: this.state.id,
        updateData: updateData
      }
    });
    this.props.dispatch({ type: "LOAD_END" });
    if (result.data.success) {
      Toast(200, t('Updated successfully'));
    } else {
      Toast(400, result.data.error);
    }
  };
  onLoad = () => {
    let self = this;
    const id = this.props.match.params.survey_id;
    const url = api_url + `survey/get`;
    const header = "Bearer ".concat(this.props.user.token);
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.props.dispatch({ type: "LOAD_START" });
    axios({
      url,
      method: "get",
      params: {
        id: id
      },
      headers: {
        authorization: "Bearer ".concat(this.props.user.token)
      }
    })
      .then(function (response) {
        if (!response.data.success) {
          Toast(400, response.data.error);
        } else {
          const data = response.data.data
          self.setState({
            endmessages: data.endmessages,
            mainData: data.main,
            surveyQuestions: data.questions,
            selectedLanguage: data.main[0].language,
            available_languages: data.main.map(m => m.language),
            image_url: data.image_url
          });
        }
        self.props.dispatch({ type: "LOAD_END" });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.history.replace('/')
        self.props.dispatch({ type: "LOAD_END" });
        Toast(500);
      });
  };
  setMainData = (name, value) => {

    const { mainData, selectedLanguage } = this.state
    let newMainData = mainData.map((item) => {
      if (item.language === selectedLanguage) {
        item[name] = value
      }
      return item
    })
    this.setState({
      mainData: newMainData
    });
  };
  createNewSection = (title) => {
    const surveyQuestions = this.state.surveyQuestions
    const newSurveyQuestions = surveyQuestions.map((question) => {
      let sections = [].concat(question.sections)
      sections.push({
        questions: [],
        display: true,
        sectionTitle: title
      })
      return {
        language: question.language,
        sections: sections
      }
    })
    this.setState({
      surveyQuestions: newSurveyQuestions,
      alert: null
    }, () => this.updateSurvey({ questions: newSurveyQuestions }))
  }
  getSectionTitle = () => {
    this.setState({
      alert: <InputModal title={t('Enter Section Title')} handleSave={(title) => this.createNewSection(title)} handleClose={() => this.setState({ alert: null })} />
    })
  };


  // Move a section from oldIndex to newIndex. Build brand-new arrays/objects (immutable) so React
  // re-renders immediately — the old in-place swap mutated the state array, so the change only
  // showed after a page refresh. A splice-move is also correct for a multi-position drag.
  onSectionSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return
    const newSurveyQuestions = this.state.surveyQuestions.map((question) => {
      const sections = [...question.sections]
      if (newIndex < 0 || newIndex >= sections.length) return { language: question.language, sections }
      const [moved] = sections.splice(oldIndex, 1)
      sections.splice(newIndex, 0, moved)
      return { language: question.language, sections }
    })
    this.setState({ surveyQuestions: newSurveyQuestions, alert: null, listVersion: this.state.listVersion + 1 },
      () => this.updateSurvey({ questions: newSurveyQuestions }))
  };
  // Move a section to a typed target position (1-based): e.g. type "2" on section 15 → it becomes
  // the 2nd section. Clamps to range; a no-op if it's already there. Clears the input afterwards.
  moveSectionToPosition = (fromKey) => {
    const q = this.state.surveyQuestions.find(x => x.language === this.state.selectedLanguage) || this.state.surveyQuestions[0]
    const len = q ? q.sections.length : 0
    const raw = this.state.sectionMoveTo[fromKey]
    const target = parseInt(raw, 10)
    if (isNaN(target)) return
    const to = Math.max(0, Math.min(len - 1, target - 1))
    this.setState(prev => { const m = { ...prev.sectionMoveTo }; delete m[fromKey]; return { sectionMoveTo: m } })
    if (to !== fromKey) this.onSectionSortEnd({ oldIndex: fromKey, newIndex: to })
  }
  onQuestionSortEnd = (sectionIndex, oldIndex, newIndex) => {
    if (oldIndex === newIndex) return
    const newSurveyQuestions = this.state.surveyQuestions.map((question) => {
      const sections = question.sections.map((sec, i) => {
        if (i !== sectionIndex) return sec
        const questions = [...sec.questions]
        if (newIndex < 0 || newIndex >= questions.length) return sec
        const [moved] = questions.splice(oldIndex, 1)
        questions.splice(newIndex, 0, moved)
        return { ...sec, questions }
      })
      return { language: question.language, sections }
    })
    this.setState({ surveyQuestions: newSurveyQuestions, alert: null, listVersion: this.state.listVersion + 1 },
      () => this.updateSurvey({ questions: newSurveyQuestions }))
  };
  setVisibleSector = (sectionKey, visible) => {
    const surveyQuestions = this.state.surveyQuestions
    const newSurveyQuestions = surveyQuestions.map((question) => {
      let sections = question.sections
      sections[sectionKey].display = visible
      return {
        language: question.language,
        sections: sections
      }
    })
    this.setState({
      surveyQuestions: newSurveyQuestions,
    }, () => this.updateSurvey({ questions: newSurveyQuestions }))
  }


  // Store a section's conditional-visibility rule (or clear it) across ALL language variants —
  // it's structural (references a question id + option values, both language-independent), like
  // the display switch and section order.
  setSectionVisibility = (sectionKey, visibility) => {
    const surveyQuestions = this.state.surveyQuestions
    const newSurveyQuestions = surveyQuestions.map((question) => {
      let sections = question.sections
      if (visibility) sections[sectionKey].visibility = visibility
      else delete sections[sectionKey].visibility
      return { language: question.language, sections: sections }
    })
    this.setState({ surveyQuestions: newSurveyQuestions },
      () => this.updateSurvey({ questions: newSurveyQuestions }))
  }

  // Answer options of a choice question (radio/checkbox), incl. star-type radios with implicit 1..N.
  optionsOfQuestionData = (q) => {
    const qq = (q && q.question) || {}
    if (qq.type === 'radio' && (qq.direction === '5star' || qq.direction === '10star')) {
      const n = qq.direction === '10star' ? 10 : 5, arr = []
      for (let v = 1; v <= n; v++) arr.push({ value: v, label: `${v} ★` })
      return arr
    }
    return (qq.options || []).map(o => ({ value: o.value, label: o.label }))
  }

  // Compact "Show this section only if <earlier question> includes <options>" editor. Gate
  // candidates are the choice questions (checkbox/radio) that live in EARLIER sections.
  renderSectionVisibility = (sections, key) => {
    const section = sections[key]
    const gates = []
    sections.forEach((s, si) => {
      if (si >= key) return
      (s.questions || []).forEach(q => {
        if (q.question && (q.question.type === 'checkbox' || q.question.type === 'radio')) {
          gates.push({ label: `${s.sectionTitle} › ${q.questionTitle}`, value: q.id, q })
        }
      })
    })
    if (!gates.length) return null
    const vis = section.visibility || null
    const selectedGate = vis ? gates.find(g => g.value === vis.questionId) : null
    const valueOptions = selectedGate ? this.optionsOfQuestionData(selectedGate.q).map(o => ({ label: o.label, value: o.value })) : []
    const selectedValues = (vis && Array.isArray(vis.values)) ? vis.values.map(String) : []
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', background: '#f4f8f5', border: '1px solid #e2e8e4', borderRadius: 8, padding: '8px 12px', margin: '0 0 10px' }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: '#5d6d66' }}>🔀 {t('Show only if:')}</span>
        <div style={{ minWidth: 220 }}>
          <CustomSelect isClearable placeholder={t('Question')}
            value={selectedGate ? { label: selectedGate.label, value: selectedGate.value } : null}
            onChange={(opt) => this.setSectionVisibility(key, opt ? { questionId: opt.value, op: 'includes', values: [] } : null)}
            options={gates.map(g => ({ label: g.label, value: g.value }))} />
        </div>
        {selectedGate &&
          <>
            <span style={{ fontSize: 13, color: '#8a988f' }}>{t('includes')}</span>
            <div style={{ minWidth: 220 }}>
              <CustomSelect isMulti placeholder={t('Answers')}
                value={valueOptions.filter(o => selectedValues.indexOf(String(o.value)) >= 0)}
                onChange={(vals) => this.setSectionVisibility(key, { questionId: vis.questionId, op: 'includes', values: (vals || []).map(v => v.value) })}
                options={valueOptions} />
            </div>
            <Button justIcon size="sm" color="danger" onClick={() => this.setSectionVisibility(key, null)}><RemoveCircle /></Button>
          </>}
      </div>
    )
  }

  updateSectorTitle = (sectionKey, value) => {
    const surveyQuestions = this.state.surveyQuestions
    const newSurveyQuestions = surveyQuestions.map((question) => {
      let sections = question.sections
      sections[sectionKey].sectionTitle = value
      return {
        language: question.language,
        sections: sections
      }
    })
    this.setState({
      surveyQuestions: newSurveyQuestions,
    }, () => this.updateSurvey({ questions: newSurveyQuestions }))
  }
  removeQuestion = (sectionIndex, questionIndex) => {
    if (!window.confirm(t('Are you sure?'))) return
    const surveyQuestions = this.state.surveyQuestions

    const newSurveyQuestions = surveyQuestions.map((question) => {
      let sections = question.sections
      let section = sections[sectionIndex]
      section.questions.splice(questionIndex, 1)

      return {
        language: question.language,
        sections: sections
      }
    })

    this.setState({
      surveyQuestions: newSurveyQuestions,
      alert: null
    }, () => this.updateSurvey({ questions: newSurveyQuestions }))
  }
  changeLanguage = (language) => {
    const { surveyQuestions, mainData } = this.state
    let newSurveyQuestions = []
    let otherSurveyQuestions = surveyQuestions.filter(q => q.language != language)
    let questionOfCurrentLanguage = surveyQuestions.filter((q) => q.language === language)[0]
    newSurveyQuestions = [questionOfCurrentLanguage, ...otherSurveyQuestions]

    let newMainData = []
    let otherMainData = mainData.filter(q => q.language != language)
    let mainDataOfCurrentLanguage = mainData.filter((q) => q.language === language)[0]
    newMainData = [mainDataOfCurrentLanguage, ...otherMainData]

    this.setState({ selectedLanguage: language, mainData: newMainData, surveyQuestions: newSurveyQuestions }, () => this.updateSurvey({
      main: newMainData,
      questions: newSurveyQuestions
    }))

  }
  render() {
    if (!this.state.mainData || this.state.mainData.length === 0) return null;
    const { classes } = this.props;
    const { id, languages, image_url, mainData, endmessages, surveyQuestions, selectedLanguage, available_languages } = this.state
    if (!surveyQuestions) {
      this.props.history.replace('/')
      return null
    }
    let mainDataOfCurrentLanguage = mainData.filter((item) => item.language === selectedLanguage)[0]
    let questionOfCurrentLanguage = surveyQuestions.filter((item) => item.language === selectedLanguage)[0]
    const { title, description, language } = mainDataOfCurrentLanguage;
    const available_language_options = languages.filter(lang => available_languages.includes(lang.value))
    return (
      <div>
        {this.state.alert}
        <GridContainer>
          <GridItem xs={12} sm={12}>
            <Card>
              <CardHeader color="success" icon>
                <CardIcon color="success">
                  <Edit />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{t('Edit survey')}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} md={3}>
                    <br />
                    <ImageUpload
                      addButtonProps={{
                        color: "rose",
                        round: true
                      }}
                      changeButtonProps={{
                        color: "rose",
                        round: true
                      }}
                      removeButtonProps={{
                        color: "danger",
                        round: true
                      }}
                      defaultImage={image_url}
                      handleImageChange={file =>
                        this.setState({
                          image_file: file
                        })
                      }
                    />
                  </GridItem>
                  <GridItem xs={12} md={9}>
                    <CustomInput
                      labelText={t('Title')}
                      id="Title"
                      formControlProps={{
                        onChange: e =>
                          this.setMainData("title", e.target.value),
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        value: title
                      }}
                    />
                    <textarea
                      className={classes.descriptionTextArea}
                      placeholder={t('Description')}
                      onChange={e =>
                        this.setMainData("description", e.target.value)
                      }
                      value={description}
                    />
                    <br />
                    <p><b>Choose default language:</b></p>
                    <CustomSelect
                      onChange={country => {
                        this.changeLanguage(country.value)
                      }}
                      placeholder={t('Language')}
                      value={languages.filter((item) => item.value === selectedLanguage)[0]}
                      options={available_language_options}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button color="info" onClick={() => this.saveSurvey()}>
                  {t('Save')}
                </Button>
                <Button color="success" onClick={() => this.getSectionTitle()}>
                  {t('New Section')}
                </Button>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12}>
            <EndMessageSection endmessages={endmessages} survey_id={this.state.id} />
          </GridItem>
          <GridItem xs={12} sm={12}>
            <Card>
              <CardHeader color="success" icon>
                <CardIcon color="success">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{t('Edit question')}</h4>
              </CardHeader>
              <CardBody>
                <SortableContainer key={`sections-${this.state.listVersion}`} onSortEnd={this.onSectionSortEnd} pressDelay={200}>
                  {
                    questionOfCurrentLanguage.sections.map((item, key) => {
                      const value = <TitleBox onSaveTitle={(newtitle) => { this.updateSectorTitle(key, newtitle) }}
                        titleEditable={true} title={item.sectionTitle} rightButton={<div style={{ whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                          <span style={{ fontSize: 12, color: '#8a988f', fontWeight: 600 }}>{t('Position')}</span>
                          <input type="number" min={1} max={questionOfCurrentLanguage.sections.length}
                            value={this.state.sectionMoveTo[key] !== undefined ? this.state.sectionMoveTo[key] : (key + 1)}
                            onChange={e => this.setState({ sectionMoveTo: { ...this.state.sectionMoveTo, [key]: e.target.value } })}
                            onKeyDown={e => { if (e.key === 'Enter') this.moveSectionToPosition(key) }}
                            style={{ width: 52, textAlign: 'center', padding: '5px 4px', border: '1px solid #cfd8d3', borderRadius: 6, fontSize: 14 }} />
                          <Button size="sm" color="success" style={{ padding: '5px 10px', margin: 0 }} onClick={() => this.moveSectionToPosition(key)}>{t('OK')}</Button>
                          <Button justIcon size="sm" color="white" title={t('Move up')}
                            disabled={key === 0}
                            onClick={() => { if (key > 0) this.onSectionSortEnd({ oldIndex: key, newIndex: key - 1 }) }}><ArrowUpward /></Button>
                          <Button justIcon size="sm" color="white" title={t('Move down')}
                            disabled={key === questionOfCurrentLanguage.sections.length - 1}
                            onClick={() => { if (key < questionOfCurrentLanguage.sections.length - 1) this.onSectionSortEnd({ oldIndex: key, newIndex: key + 1 }) }}><ArrowDownward /></Button>
                          <Switch
                            checked={item.display}
                            onChange={e => {
                              this.setVisibleSector(key, e.target.checked)
                            }}
                            value={`${key}`}
                            color="primary"
                            classes={{

                            }}
                          />
                        </div>} color={commonStyle.whitebackgroundColor} textColor={commonStyle.blackColor}>
                        {this.renderSectionVisibility(questionOfCurrentLanguage.sections, key)}
                        <SortableContainer onSortEnd={({ oldIndex, newIndex }) => {
                          this.onQuestionSortEnd(key, oldIndex, newIndex)
                        }} pressDelay={200}>
                          {
                            item.questions.map((qitem, qkey) => {
                              const qvalue = <TitleBox key={qkey}
                                rightButton={<div style={{ whiteSpace: 'nowrap' }}>
                                  <Button justIcon color="white" size="sm" title={t('Move up')}
                                    disabled={qkey === 0}
                                    onClick={() => { if (qkey > 0) this.onQuestionSortEnd(key, qkey, qkey - 1) }}><ArrowUpward /></Button>
                                  <Button justIcon color="white" size="sm" title={t('Move down')}
                                    disabled={qkey === item.questions.length - 1}
                                    onClick={() => { if (qkey < item.questions.length - 1) this.onQuestionSortEnd(key, qkey, qkey + 1) }}><ArrowDownward /></Button>
                                  <Button justIcon color="info" size="sm" onClick={() => this.props.history.push(`/survey/${id}/${key}/${qkey}/question/edit`)}><Create /></Button>
                                  <Button justIcon color="danger" size="sm" onClick={() => this.removeQuestion(key, qkey)} > <RemoveCircle /></Button>
                                </div>}
                                title={qitem.questionTitle} color={commonStyle.whitebackgroundColor} textColor={commonStyle.blackColor}>

                                <RenderQuestion question={qitem} />
                              </TitleBox>
                              return <SortableItem key={`qitem-${qkey}`} index={qkey} value={qvalue} />
                            })
                          }
                          <Button color="success" size="sm" onClick={() => this.props.history.push(`/survey/${id}/${key}/-1/question/edit`)}>
                            {t('Add New Question')}
                          </Button>
                        </SortableContainer>
                      </TitleBox>
                      return <SortableItem key={`item-${key}`} index={key} value={value} />
                    })
                  }
                </SortableContainer>

                <Button color="success" onClick={() => this.getSectionTitle()}>
                  {t('New Section')}
                </Button>
              </CardBody>
              <CardFooter>

              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(SurveyEditPage)));
